import { Stack, Text } from '@eigtech/ui-shared-dave'

export type LocationCellProps = {
  location: {
    addressLine1: string
    addressLine2?: string
    addressLine3?: string
    city?: string
    state?: string
    zip?: string
  }
}
export function LocationCell({ location }: LocationCellProps) {
  if (!location) return null

  const cityState = `${location.city ? `${location.city}, ` : ''}${location.state ?? ''} ${
    location.zip ?? ''
  }`.trim()

  return (
    <Stack as={Text}>
      <Text as="span">{location.addressLine1}</Text>
      {!!location.addressLine2 && <Text as="span">{location.addressLine2}</Text>}
      {!!location.addressLine3 && <Text as="span">{location.addressLine3}</Text>}
      {!!cityState && <Text as="span">{cityState}</Text>}
    </Stack>
  )
}
